import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import "../UiStyle/Others.css";

const CancellationRefundPolicy = () => {
  return (
    <Fragment>
      <Navbar />
      <PageTitle
        pageTitle={"Cancellation & Refund Policy"}
        pagesub={"Cancellation & Refund Policy"}
      />
      <div className="container policy" style={{ marginTop: 50 }}>
        <p className="mb-4">
          At <strong>Chemist For All</strong>, we strive to process every order
          efficiently and accurately. However, there may be situations where an
          order must be canceled either by us or at your request. This policy
          outlines how cancellations and refunds are handled.
        </p>

        <h2 className="mt-6 mb-2 policy-title">
          Order Cancellation by Chemist For All
        </h2>
        <p className="mb-3">
          While we do our best to fulfill every order, certain circumstances may
          prevent us from processing your request. Orders may be canceled for
          reasons such as:
        </p>
        <ul className="list-disc list-inside mb-4 space-y-1">
          <li>Unavailability of the selected product(s)</li>
          <li>Limitations on the quantity that can be purchased</li>
          <li>Payment issues, including failed or flagged transactions</li>
          <li>Concerns raised by our fraud prevention or compliance checks</li>
        </ul>
        <p className="mb-4">
          If we are unable to fulfill all or part of your order, our customer
          care team will notify you promptly. In cases where your payment has
          already been processed, the charged amount will be refunded to your
          original payment method.
        </p>

        <h2 className="mt-6 mb-2 policy-title">Unpaid Orders</h2>
        <p className="mb-4">
          Orders placed without successful payment are automatically canceled
          and will not be processed.
        </p>

        <h2 className="mt-6 mb-2 policy-title">
          Order Cancellation by the Customer
        </h2>
        <p className="mb-4">
          If you need to cancel an order, please contact our customer care team
          as soon as possible. If your request is received before the order is
          processed or dispatched, we will cancel the order and initiate a
          refund after deducting a <strong>$50 cancellation fee</strong>.
        </p>

        <p className="mb-3 font-semibold">Please note:</p>
        <ul className="list-disc list-inside mb-4 space-y-1">
          <li>
            We cannot cancel orders that have already been processed, packed, or
            shipped.
          </li>
          <li>
            In some cases, processing can begin within 12 hours of placing the
            order.
          </li>
        </ul>

        <h2 className="mt-6 mb-2 policy-title">Refund Policy</h2>
        <p className="mb-4">
          We process refunds based on the original mode of payment:
        </p>
        <ul className="list-disc list-inside mb-4 space-y-1">
          <li>
            <strong>Credit/Debit Card Payments:</strong> Refunded back to the
            same card.
          </li>
          <li>
            <strong>E-Checks:</strong> If you paid using an e-check, refunds
            will be processed manually after our Customer Support Team contacts
            you to collect your bank account details, including account number,
            routing number, and account holder name.
          </li>
        </ul>
        <p className="mb-4">
          We aim to process all eligible refunds within{" "}
          <strong>10 business days</strong>. Delays in crediting refunds to
          cardholder accounts are subject to the policies of the issuing bank,
          and we are not responsible for such delays.
        </p>
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default CancellationRefundPolicy;
